var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForestAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V12C16 13.9528 14.6006 15.5787 12.75 15.9298V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V15.9298C9.39935 15.5787 8 13.9528 8 12V6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C6.5 13.3614 6.99424 14.6065 7.81301 15.5665C7.48254 15.7348 7.12557 15.8586 6.75 15.9298V22C6.75 22.4142 6.41421 22.75 6 22.75C5.58579 22.75 5.25 22.4142 5.25 22V15.9298C3.39935 15.5787 2 13.9528 2 12C2 9.79086 3.79086 8 6 8C6.16933 8 6.3362 8.01052 6.5 8.03095V12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12C17.5 13.3614 17.0058 14.6065 16.187 15.5665C16.5175 15.7348 16.8744 15.8586 17.25 15.9298V22C17.25 22.4142 17.5858 22.75 18 22.75C18.4142 22.75 18.75 22.4142 18.75 22V15.9298C20.6006 15.5787 22 13.9528 22 12C22 9.79086 20.2091 8 18 8C17.8307 8 17.6638 8.01052 17.5 8.03095V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForestAlt2);
export default __webpack_public_path__ + "static/media/forest-alt-2.ca1acb2e57b36d485eca15b72fe278e1.svg";
export { ForwardRef as ReactComponent };